import { connect } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';
import AccessTokenGuard from './access-token-guard.component';

const mapStateToProps = ({ firebase }) => ({
  isLoaded: isLoaded(firebase?.auth) ?? false,
});

export default connect(mapStateToProps)(AccessTokenGuard);
